import { NAME } from "./constants";

export const SET_IS_DATA_SUBMITTED = `${NAME}/SET_IS_DATA_SUBMITTED`;

export const SET_LOOK_UP_DATA = `${NAME}/SET_LOOK_UP_DATA`;